import { useState } from 'react';
import Card from '../../../components/atoms/card';
import SearchBar from '../../../components/organisms/monitor/search-bar';
import GeneralProblem, {
	GeneralProblemForm,
} from '../../../components/organisms/monitor/general-problem';
import RetroactiveMonitoring, {
	RetroactiveMonitoringForm,
} from '../../../components/organisms/monitor/retroactive-monitoring';
import SelectYard from '../../../components/organisms/monitor/select-yard';
import MonitoringContainers, {
	MonitoringForm,
} from '../../../components/organisms/monitor/containers';
import { useRouteLoaderData } from 'react-router-dom';
import { HomeLoaderData } from '../../../types/homeLoaderData';
import { IYard } from '../../../services/Yard.service';

const Monitoring = () => {
	const { user } = useRouteLoaderData('home') as HomeLoaderData;

	const [monitorings, setMonitorings] = useState<MonitoringForm[]>([]);
	const [search, setSearch] = useState<string>('');
	const [yardSelected, setYardSelected] = useState<IYard>();

	const [generalProblemData, setGeneralProblemData] =
		useState<GeneralProblemForm>({
			isProblem: false,
			description: '',
		});

	const [retroactiveData, setRetroactiveData] =
		useState<RetroactiveMonitoringForm>({
			date: new Date(),
			dayState: 'AM',
			description: '',
			isAvailable: false,
		});

	const atualizarDescricaoMonitoramentos = (descricao: string) => {
		setMonitorings((prev) =>
			prev.map((item) => ({ ...item, observation: descricao }))
		);
	};

	return (
		<div className="flex flex-col gap-6">
			{user.type === 'User' && (
				<>
					<Card className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 p-6">
						<SelectYard
							yardSelected={yardSelected}
							setYardSelected={setYardSelected}
							monitorings={monitorings}
							setMonitorings={setMonitorings}
						/>
						<GeneralProblem
							data={generalProblemData}
							setData={setGeneralProblemData}
							monitorings={monitorings}
							aoAlterarDescricao={atualizarDescricaoMonitoramentos}
						/>
						<RetroactiveMonitoring
							data={retroactiveData}
							setData={setRetroactiveData}
							aoAlterarDescricao={atualizarDescricaoMonitoramentos}
						/>
					</Card>
					<SearchBar
						yardSelected={yardSelected}
						data={monitorings}
						generalProblemData={generalProblemData}
						retroactiveData={retroactiveData}
						search={search}
						setSearch={setSearch}
						monitorings={monitorings}
						setMonitorings={setMonitorings}
					/>
				</>
			)}
			<MonitoringContainers
				data={monitorings}
				setData={setMonitorings}
				generalProblemData={generalProblemData}
				search={search}
				disabled={user.type !== 'User'}
			/>
		</div>
	);
};

export default Monitoring;
